<div
  class="flex w-full flex-col gap-7 rounded-lg border border-grey-lightGrey bg-white p-8"
  *transloco="let t"
>
  <div class="flex w-full flex-row gap-4">
    <div class="flex size-[50px] shrink-0 rounded-md bg-blue-100">
      <mat-icon
        class="material-symbols-outlined !inline-flex !h-full !w-full items-center justify-center text-2xl text-blue group-hover:text-blue"
      >
        {{ icon }}
      </mat-icon>
    </div>
    <div class="flex grow flex-col">
      <h3 class="text-lg font-semibold">
        {{
          t('portal.courseSettings.topicAreaSettings.topicAreas.' + headline)
        }}
      </h3>
      @for (topicArea of topicAreas; track topicArea) {
        @if (topicArea.key === headline) {
          <p class="text-dark-grey text-sm">
            {{
              t('portal.courseSettings.topicAreaSettings.availableSettings', {
                settingsCount: topicArea.variable.length,
              })
            }}
          </p>
        }
      }
    </div>
    <div class="flex max-w-[500px] text-right text-grey">
      {{ t('portal.courseSettings.topicAreaSettings.fieldExplanation') }}
    </div>
  </div>
  <div class="flex w-full border border-b-grey-lightGrey"></div>

  @for (topicArea of topicAreas; track topicArea) {
    @if (topicArea.key === headline) {
      @if (topicArea.variable.length === 0) {
        <div
          class="flex max-w-[1000px] flex-col items-center gap-3 rounded-xl bg-grey-veryLightGrey p-6"
        >
          <p class="font-semibold text-grey">
            {{
              t(
                'portal.courseSettings.topicAreaSettings.noAvailableSettings.title'
              )
            }}
          </p>
          <p class="text-xs text-grey">
            {{
              t(
                'portal.courseSettings.topicAreaSettings.noAvailableSettings.message',
                {
                  topicArea: t(
                    'portal.courseSettings.topicAreaSettings.topicAreas.' +
                      headline
                  ),
                }
              )
            }}
          </p>
        </div>
      } @else {
        @for (variable of topicArea.variable; track variable) {
          <app-variable-block [variableName]="variable"> </app-variable-block>
        }
      }
    }
  }
</div>
